import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { holdsPermission } from '../../session/permissions.js';
import { meQueryOptions } from '../../session/use-current-user.js';

/**
 * The tickets area.
 *
 * `tickets.read` without a resource, because a link names no ticket: who may read *which* ticket
 * is the API's to answer on every request, and the gate here is only about whether this person has
 * any business on the screen at all.
 */
export const Route = createFileRoute('/tickets')({
  async beforeLoad({ context }) {
    const me = await context.queryClient.ensureQueryData(meQueryOptions());
    if (!holdsPermission(me, 'tickets.read')) {
      throw redirect({ to: '/', search: { denied: 'tickets.read' } });
    }
  },
  component: () => (
    <div className="flex h-full flex-col">
      <Outlet />
    </div>
  ),
});
